// @flow
import { getAuthToken, getBidderId, LOG_OUT_BIDDER } from './user';
import { createSelector } from 'reselect';
import { getDeployment } from './config';
import { getLAPaymentCustomers } from '../api/payment';
import type { GlobalState } from '../rootReducer';

/* Action Types */
export const LOAD_LA_PAYMENT_CUSTOMER_FAIL = 'la/ui/loadLAPaymentCustomer/FAIL';
export const LOAD_LA_PAYMENT_CUSTOMER_REQUEST = 'la/ui/loadLAPaymentCustomer/REQUEST';
export const LOAD_LA_PAYMENT_CUSTOMER_SUCCESS = 'la/ui/loadLAPaymentCustomer/SUCCESS';

const transformPayloadToLACustomers = (payload: any) => {
    const laPaymentCustomers = {};

    if (payload && Array.isArray(payload)) {
        payload.forEach(cust => {
            if (cust.providerId === 3) {
                laPaymentCustomers.payrix = { ...cust };
            }
        });
    }
    return laPaymentCustomers;
};

// reducer
const DEFAULT_STATE = {
    laPaymentCustomers: {},
    loaded: 0,
    loading: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_LA_PAYMENT_CUSTOMER_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case LOAD_LA_PAYMENT_CUSTOMER_SUCCESS:
            return {
                ...state,
                laPaymentCustomers: transformPayloadToLACustomers(action.payload),
                loaded: action.meta.actionTime,
                loading: false,
            };
        case LOAD_LA_PAYMENT_CUSTOMER_FAIL:
        case LOG_OUT_BIDDER:
            return DEFAULT_STATE;
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.paymentCustomer;
const providerIdSelector = (state: GlobalState, providerId) => providerId;

const lAPaymentCustomersSelector = createSelector(stateSelector, state => state.laPaymentCustomers);

export const payrixCustomerSelector = createSelector(
    lAPaymentCustomersSelector,
    laPaymentCustomers => laPaymentCustomers.payrix || {},
);

export const getPaymentCustomer = createSelector(
    [payrixCustomerSelector, providerIdSelector],
    (payrixCustomer, providerId) => {
        if (providerId === 'payrix') {
            return payrixCustomer;
        }

        return {};
    },
);

/* ACTION CREATORS */
export const fetchLAPaymentCustomersIfNeeded = () => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const bidderId = getBidderId(state);
        const deployment = getDeployment(state);

        dispatch({
            type: LOAD_LA_PAYMENT_CUSTOMER_REQUEST,
        });
        const response = await getLAPaymentCustomers({ authToken, bidderId, deployment, userType: 'bidder' });
        return dispatch({
            meta: { actionTime: Date.now() },
            payload: response.payload,
            type: LOAD_LA_PAYMENT_CUSTOMER_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: LOAD_LA_PAYMENT_CUSTOMER_FAIL,
        });
    }
};
